import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { LaboratorioService } from '../laboratorio.service';
import { UnidadeService } from '../../shared/services/unidade.service';

@Component({
  templateUrl: './gerenciar-laboratorio.component.html',
})
export class GerenciarLaboratorioComponent extends WebPage implements OnInit {

  unidades;
  laboratorios;
  usuario;
  constructor(
    messageService: MessageService,
    private laboratorioService: LaboratorioService, private unidadeService: UnidadeService
  ) {
    super(messageService);
    this.usuario = JSON.parse(localStorage.getItem('usuarioGestao'));
    console.log(this.usuario);

  }

  ngOnInit() {
    const mensagem = localStorage.getItem('mensagem');
    if (mensagem != null && mensagem !== '') {
      this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: mensagem });
      localStorage.removeItem('mensagem');
    }
    this.isLoading = true;

    if (this.usuario.Perfil === '#ADMINISTRATIVOUNIDADEOPERACIONAL'
    || this.usuario.Perfil === '#GESTORUNIDADEOPERACIONAL') {
      this.laboratorioService.getByUnidade(this.usuario.IdUnidade)
      .finally(() => this.isLoading = false)
      .subscribe(
        laboratorios => this.laboratorios = laboratorios,
        error => this.gerenciaErro(error)
      );

      this.unidadeService.getUnidades()
      .finally(() => this.isLoading = false)
      .subscribe(
        unidades => this.unidades = unidades,
        error => this.gerenciaErro(error)
      );

    } else {
      Observable.combineLatest(
        this.unidadeService.getUnidadesParticipantes(),
        this.laboratorioService.getAllFull()
      )
      .finally(() => this.isLoading = false)
      .subscribe(
        combined => {
          this.unidades = combined[0];
          this.laboratorios = combined[1];
        },
        error => this.gerenciaErro(error)
      );
    }
  }

  carregarLaboratorios(idUnidade) {
    if (idUnidade === '') {
      this.laboratorios = [];
      return;
    }

    if (this.usuario.Perfil === '#ADMINISTRATIVOUNIDADEOPERACIONAL'
    || this.usuario.Perfil === '#GESTORUNIDADEOPERACIONAL') {
      this.isLoading = true;
      this.laboratorioService.getByUnidade(this.usuario.IdUnidade)
        .finally(() => this.isLoading = false)
        .subscribe(
          laboratorios => this.laboratorios = laboratorios,
          error => this.gerenciaErro(error)
        );
    } else {
    this.isLoading = true;
    this.laboratorioService.getByUnidade(idUnidade)
      .finally(() => this.isLoading = false)
      .subscribe(
        laboratorios => this.laboratorios = laboratorios,
        error => this.gerenciaErro(error)
      );
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/components/laboratorio/gerenciar-laboratorio/gerenciar-laboratorio.component.ts